import { render, staticRenderFns } from "./CompareHeader.vue?vue&type=template&id=52d35e88"
import script from "./CompareHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports